import SectionReveal from './SectionReveal';

export default function WhyUsSection({ t }) {
  const whyItems = t?.whyItems || [
    'Միջազգային տեխնոլոգիաների ինտեգրատոր',
    'Անհատական ինժեներական լուծումներ',
    'Համաշխարհային գործընկերների սարքավորումներ',
    'Նախագծում, մատակարարում և տեղադրում',
    'Երաշխիքային և հետերաշխիքային սպասարկում',
    'Երկարաժամկետ տեխնիկական աջակցություն',
    'Էկոլոգիական և կայուն լուծումներ'
  ];

  return (
    <section id="why-us" className="relative bg-white px-3 py-20 md:px-10">
      
      <div className="mx-auto max-w-7xl space-y-12">
        
        {/* Блок 1: Заголовок + преимущества */}
        <SectionReveal>
          <div className="md:border-l-4 border-l-2 border-[#0FA4E8] bg-gray-50 p-3 md:p-10">
            
            <h2 className="text-2xl md:text-4xl font-black text-[#0B3B6F] uppercase mb-8">
              {t?.whyTitle || 'Ինչու ընտրել NWTA-ն'}
            </h2>
            
            <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {whyItems.map((item, idx) => (
                <div key={idx} className="flex items-start gap-3 p-4 bg-white border border-gray-100 hover:border-[#0FA4E8]/30 transition-all group">
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-[#0FA4E8]/10 text-[#0FA4E8] text-xs font-bold group-hover:bg-[#0FA4E8] group-hover:text-white transition-colors">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <span className="text-sm font-semibold text-[#0B3B6F] group-hover:text-[#0FA4E8] transition-colors leading-tight">
                    {item}
                  </span>
                </div>
              ))}
            </div>

          </div>
        </SectionReveal>

        {/* Блок 2: Миссия */}
        <SectionReveal delay={200}>
          <div className="md:border-l-4 border-l-2 border-[#0B3B6F] bg-gray-50 p-8 md:p-10">
            
            <h2 className="text-xl font-bold text-[#0B3B6F] uppercase tracking-wider mb-4">
              {t?.whyMissionTitle || 'Մեր առաքելությունը'}
            </h2>
            
            <p className="text-base md:text-lg text-slate-600 leading-relaxed">
              {t?.whyMissionText || 'Ապահովել Հայաստանը ժամանակակից ջրային տեխնոլոգիաներով՝ ստեղծելով մաքուր, անվտանգ և կայուն միջավայր ապագա սերունդների համար։'}
            </p>
          </div>
        </SectionReveal>

      </div>
    </section>
  );
}